import { QuestionMark } from '@mui/icons-material'
import { List, ListItem, SvgIconTypeMap, SxProps, Theme, useTheme } from '@mui/material'
import { OverridableComponent } from '@mui/material/OverridableComponent'

export interface ListSelectorProps {
  items: Record<string, string> | [string, string][] | [string][]
  icons?: (OverridableComponent<SvgIconTypeMap<{}, 'svg'>> & {
    muiName: string
  })[]
  selected: string | null
  onSelect: (item: string, idx?: number | undefined) => void
  sx?: SxProps<Theme>
  disabled?: boolean
}

/**
 * Display an icon for an appliance type.
 */
export const ListSelector = (props: ListSelectorProps): JSX.Element => {

  const { items, icons, selected, disabled, onSelect } = props
  const theme = useTheme()
  let listItems: [string, string][] = []
  const sx = {
    ...props.sx
  }

  if (items.length === undefined) {
    Object.keys(items).forEach((k: string) => listItems.push([k, (items as Record<string, string>)[k]]))
  } else {
    listItems = items as [string, string][]
  }

  return <List sx={{ sx }}>
    {listItems.map(([k, v], idx) => <ListItem
      key={idx}
      onClick={() => !disabled && onSelect(k, idx)}
      dense
      disabled={disabled}
      data-cy={`list-item-${v}`}
      aria-selected={selected === k}
      sx={{
        pl: 0,
        userSelect: 'none',
        color: k === selected ? 'primary.main' : theme.palette.grey[600],
        cursor: 'pointer',
        textDecoration: k === selected ? 'underline' : 'none',
      }}
    >
      <>
        {
          (() => {
            if (icons) {
              const Icon = icons[idx]
              return Icon ? <Icon sx={{ mr: 1 }}/> : <QuestionMark sx={{ mr: 1 }}/>
            }
            return <></>
          })()
        }
        {v}
      </>
    </ListItem>)}
  </List>
}
